import React from 'react';
import { TriangleAlertIcon, UsersRoundIcon } from 'lucide-react';
import { TL_FLOW_NOTE } from '../../data/periodClose';
import { OverrideLine } from '../../types/commission';
import { formatUsd, sumCents } from '../../utils/format';
import { Card } from '../sf/Card';
import { ExampleDataBadge } from '../sf/ExampleDataBadge';
import { Money } from '../sf/Money';
import { StoredReference } from '../sf/StoredReference';
import { UnderReviewNote } from '../sf/UnderReviewNote';
export function OverrideLinesCard({
  lines
}: {
  lines: OverrideLine[];
}) {
  const adjustedTotal = sumCents(lines.map(line => line.adjustedAmount));
  const storedTotal = sumCents(lines.map(line => line.storedAmount));
  return <Card title="Team Lead & Director rows" icon={UsersRoundIcon} iconBg="#0176D3" meta="Adjusted team / override volume × employee-record BPS ÷ 10,000. No bonus BPS on these rows." bodyClassName="" actions={<ExampleDataBadge data-id="element-652" data-mp="16t2csfpq6abw" />} data-id="element-651" data-mp="313zayd70qjq2">
      <div className="space-y-1.5 border-t border-sf-border px-4 py-2 text-xs" data-id="element-653" data-mp="2s591xzz5qb6z">
        <p className="text-sf-weak" data-id="element-654" data-mp="2nesls83ycbgx">
          Loan Officer row always created · Team Lead row skipped when Opportunity Owner = Team Leader · Director row skipped when Opportunity Owner = Division Leader and
          writes to the Opportunity’s Division Leader Commissions field.
        </p>
        <p className="flex items-start gap-1.5 rounded border border-[#F9C88C] bg-sf-amber-light px-2 py-1.5 text-sf-text" data-id="element-655" data-mp="2derzcdasdf8i">
          <TriangleAlertIcon className="mt-0.5 h-3.5 w-3.5 shrink-0 text-sf-amber-text" aria-hidden="true" data-id="element-656" data-mp="364qsokw0jyiz" />
          {TL_FLOW_NOTE}
        </p>
      </div>
      <ul className="divide-y divide-sf-border border-t border-sf-border" data-id="element-657" data-mp="314clf528ksm0">
        {lines.map(line => <li key={line.id} className="grid grid-cols-[minmax(0,1fr)_auto] gap-x-4 px-4 py-3" data-id="element-658" data-mp="2w971gbse9o0k">
            <div className="min-w-0" data-id="element-659" data-mp="1poxnnz27dwpu">
              <p className="flex flex-wrap items-center gap-2 text-[13px]" data-id="element-660" data-mp="1krfm4tqimjrv">
                <span className="font-semibold" data-id="element-661" data-mp="csia6fk2dc87">{line.name}</span>
                <span className="text-sf-weak" data-id="element-662" data-mp="ct9uuvc4hpjp">· {line.role === 'Director/DL' ? `${line.branch} Director/DL` : `Team Lead, ${line.branch}`}</span>
                <span className="font-mono text-[11px] text-sf-weak" data-id="element-663" data-mp="2ukkroqgx9e0">{line.ruleKey}</span>
              </p>
              <p className="mt-0.5 text-[13px] tabular-nums" data-id="element-664" data-mp="7svve1ol7nxa">
                {formatUsd(line.adjustedVolume)} adjusted {line.role === 'Team Lead' ? 'team' : 'override'} volume × {line.bps} bps
                <span className="text-xs text-sf-weak" data-id="element-665" data-mp="3u15930p5237c"> – from employee record: {line.bpsField}</span>
              </p>
              <p className="text-[11px] text-sf-weak" data-id="element-666" data-mp="3ga9x3fjcf5zj">
                Stored (unadjusted) volume – reference {formatUsd(line.storedVolume)} · Bonus: none
              </p>
              <p className="text-xs text-sf-weak" data-id="element-667" data-mp="36bayyqw7esqs">
                {line.skipRule} · {line.selfGenNote}
                {line.writesTo && ` · writes to ${line.writesTo}`}
              </p>
            </div>
            <div className="text-right" data-id="element-668" data-mp="2rnsotczvh5wz">
              <p className="text-xs text-sf-weak" data-id="element-669" data-mp="2roubyfu5xiv2">Adjusted · pays</p>
              <p className="text-[15px] font-bold" data-id="element-670" data-mp="2nnily97dmvmc">
                <Money value={line.adjustedAmount} data-id="element-671" data-mp="2notlfwtshh7n" />
              </p>
              <StoredReference value={line.storedAmount} compact data-id="element-672" data-mp="31o34d49dqpfb" />
            </div>
          </li>)}
        <li className="flex items-baseline justify-between gap-3 bg-[#FAFAF9] px-4 py-2 text-[13px] font-semibold" data-id="element-673" data-mp="2wlube7wibnd7">
          <span data-id="element-674" data-mp="3al3mwu9rptau">TL / Director total</span>
          <span className="text-right" data-id="element-675" data-mp="36mee7ezoczxj">
            <Money value={adjustedTotal} data-id="element-676" data-mp="36lcqob1h2kyx" />
            <span className="block" data-id="element-677" data-mp="3kcq73g4332pq">
              <StoredReference value={storedTotal} data-id="element-678" data-mp="3kbolihpfyxtr" />
            </span>
          </span>
        </li>
      </ul>
      <div className="border-t border-sf-border px-4 py-3" data-id="element-679" data-mp="3fegar26mhw2j">
        <UnderReviewNote data-id="element-680" data-mp="3uanvc3ly0zic" />
      </div>
    </Card>;
}